export default {

  SET_ROLES(state, roles) {
    state.roles = roles;
  },

  SET_USERS(state, users) {
    state.users = users;
  }, ADD_USER(state, user) {
    state.users.push(user);
  },
  SET_PERMISSION_LIST(state, permission) {
    state.permissions = permission;
    state.childrenFirst = []
    state.childrenSecond = []
    state.childrenThird = []
    state.childrenFourth = []
    state.childrenFifth = []
    state.childrenSixth = []
    state.childrenSeven = []
    state.childrenEight = []
  },

  SET_PERMISSION_FIRST_CHILDREN(state, children) {
    state.childrenFirst = children
    state.childrenThird = []
    state.childrenSecond = []
    state.childrenFourth = []
    state.childrenFifth = []
    state.childrenSixth = []
    state.childrenSeven = []
    state.childrenEight = []
  }, SET_PERMISSION_SECOND_CHILDREN(state, children) {
    state.childrenSecond = children
    state.childrenThird = [];
    state.childrenFourth = []
    state.childrenFifth = []
    state.childrenSixth = []
    state.childrenSeven = []
    state.childrenEight = []
  }, SET_PERMISSION_THIRD_CHILDREN(state, children) {
    state.childrenThird = children;
    state.childrenFourth = []
    state.childrenFifth = []
    state.childrenSixth = []
    state.childrenSeven = []
    state.childrenEight = []
  },
  SET_PERMISSION_FOURTH_CHILDREN(state, children) {
    state.childrenFourth = children;
    state.childrenFifth = []
    state.childrenSixth = []
    state.childrenSeven = []
    state.childrenEight = []

  },
  SET_PERMISSION_FIFTH_CHILDREN(state, children) {
    state.childrenFifth = children
    state.childrenSixth = []
    state.childrenSeven = []
    state.childrenEight = []

  },
  SET_PERMISSION_SIXTH_CHILDREN(state, children) {
    state.childrenSixth = children
    state.childrenSeven = []
    state.childrenEight = []


  },
  SET_PERMISSION_SEVEN_CHILDREN(state, children) {
    state.childrenSeven = children
    state.childrenEight = []

  },
  SET_PERMISSION_EIGHT_CHILDREN(state, children) {
    return state.childrenEight = children
  },

  EDIT_USER(state, value) {
    const userIndex = state.users.findIndex(u => u.id === value.id);
    state.users.splice(userIndex, 1, value);
  }
};
